/**
 * Biyometrik veriyi TARAYICIDA mühürler.
 *
 * Kalem verisi imzayı atan cihazdan çıkmadan şifreleniyor. Sunucuya
 * yalnızca mühürlü paket gidiyor; ham veri sunucunun belleğine hiç
 * girmiyor, dolayısıyla günlüklerde, bellek dökümünde veya hata ayıklama
 * araçlarında görünemiyor.
 *
 * Yöntem sunucudaki Service/biometric.js ile birebir aynı:
 *   1. Rastgele bir AES-256-GCM anahtarı üretiliyor
 *   2. Veri o anahtarla şifreleniyor
 *   3. AES anahtarı, kurumun RSA açık anahtarıyla kapatılıyor (RSA-OAEP)
 *
 * Çözmek için RSA özel anahtarı gerekiyor; o anahtar sunucuda değil,
 * noterde ya da hukuk biriminde duruyor (test/open-biometric.js).
 *
 * Tarayıcı WebCrypto'yu desteklemiyorsa (ya da sayfa HTTPS değilse)
 * veri TOPLANMIYOR. Şifresiz göndermektense hiç göndermemek doğru.
 */

function base64(buffer) {
  var bytes = new Uint8Array(buffer);
  var s = '';
  for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return window.btoa(s);
}

function fromBase64(text) {
  var binary = window.atob(text);
  var bytes = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

// WebCrypto yalnızca güvenli bağlamda (HTTPS veya localhost) çalışıyor
function isAvailable() {
  return !!(window.crypto && window.crypto.subtle && window.isSecureContext);
}

/**
 * Veriyi mühürler.
 *
 * @param {string} plain      kalem verisi
 * @param {string} publicKey  kurumun açık anahtarı (SPKI, base64)
 * @returns {Promise<object|null>} sunucuya gidecek paket, ya da null
 */
function seal(plain, publicKey) {
  if (!isAvailable() || !plain || !publicKey) return Promise.resolve(null);

  var subtle = window.crypto.subtle;
  var data = new TextEncoder().encode(plain);
  var iv = window.crypto.getRandomValues(new Uint8Array(12));
  var aesKey;

  return subtle.generateKey({ name: 'AES-GCM', length: 256 }, true, ['encrypt'])
    .then(function (key) {
      aesKey = key;
      return subtle.encrypt({ name: 'AES-GCM', iv: iv, tagLength: 128 }, key, data);
    })
    .then(function (encrypted) {
      // WebCrypto doğrulama etiketini şifreli metnin sonuna ekliyor;
      // Node tarafı ikisini ayrı beklediği için burada ayırıyoruz
      var all = new Uint8Array(encrypted);
      var tag = all.slice(all.length - 16);
      var body = all.slice(0, all.length - 16);

      return Promise.all([
        subtle.exportKey('raw', aesKey),
        subtle.importKey('spki', fromBase64(publicKey),
          { name: 'RSA-OAEP', hash: 'SHA-256' }, false, ['encrypt'])
      ]).then(function (parts) {
        return subtle.encrypt({ name: 'RSA-OAEP' }, parts[1], parts[0])
          .then(function (sealedKey) {
            return {
              alg: 'AES-256-GCM + RSA-OAEP-SHA256',
              key: base64(sealedKey),
              iv: base64(iv),
              tag: base64(tag),
              data: base64(body),
              size: plain.length
            };
          });
      });
    })
    .catch(function () {
      // Şifreleyemediysek veri gönderilmiyor
      return null;
    });
}

export default { isAvailable, seal };



// WEBPACK FOOTER //
// ./src/config/biometricSeal.js